export const TERMS_VERSION = 'clinic-terms-v1';
export const PRIVACY_POLICY_VERSION = 'clinic-privacy-v1';

// 2026-09-10 legal-risk audit, findings #1-2. Versioned so a future copy
// change never requires a schema change -- just bump the version string
// here (and the matching hardcoded literal in migration 215) and update
// the screen's copy. VCPR copy finalized 2026-09-10 (Bryan's exact text).
export const CLINICAL_ATTESTATION_VERSION = 'clinical-attestation-v1';
export const VCPR_ATTESTATION_VERSION = 'vcpr-attestation-v1';
